"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _date = require("@/utils/date");
var _utils = require("@/utils");
var _surchargeAndMiscellaneous = require("@/api/query/surchargeAndMiscellaneous");
var _Export2Excel = require("@/utils/Export2Excel");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'surchargeAndMiscellaneous',
  data: function data() {
    return {
      loading: false,
      sortRule: {
        prop: null,
        order: null
      },
      //默认的排序列和排序书序
      tabData: [],
      isCnLang: false,
      showDefault: false,
      form: {
        por: '',
        del: '',
        freightType: '',
        containerType: '',
        transitClause: 'CY-CY',
        cargoType: '0001',
        paidType: '',
        defaultPaidType: '0',
        date: ''
      },
      formRules: {
        por: [{
          required: true,
          message: this.$t('validate.pol'),
          trigger: 'blur'
        }],
        del: [{
          required: true,
          message: this.$t('validate.pod'),
          trigger: 'blur'
        }]
      },
      isResult: false,
      containerList: [],
      transitClauseList: [],
      cargoTypeList: [],
      tableData: [],
      page: {
        total: 0,
        pageIndex: 1,
        pageSize: 50
      }
    };
  },
  created: function created() {
    var _this2 = this;
    this.isCnLang = this.$i18n.locale === 'zh';
    (0, _surchargeAndMiscellaneous.fetchList)({
      pageSize: 100
    }).then(function (response) {
      _this2.containerList = response.data.records;
    });
    (0, _surchargeAndMiscellaneous.searchTransitClause)({
      pageSize: 100
    }).then(function (response) {
      _this2.transitClauseList = response.data.records;
      _this2.transitClauseList.unshift({
        serviceModeCode: ''
      });
    });
    (0, _surchargeAndMiscellaneous.fetchCargoTypeList)({
      pageSize: 100
    }).then(function (response) {
      _this2.cargoTypeList = response.data.records;
    });
  },
  methods: {
    validateNull: _validate.validateNull,
    validAlphabets: _validate.validAlphabets,
    export_table_to_excel: _Export2Excel.export_table_to_excel,
    //解决排序中出现空值错乱问题
    sortChange: function sortChange(column) {
      var _this = this;
      if (column.order !== null && column.prop === 'containerType') {
        var data = [];
        for (var i = 0; i < _this.tableData.length; i++) {
          if (_this.tableData[i].containerType === null) {
            data.push(_this.tableData[i]);
          } else {
            data.unshift(_this.tableData[i]);
          }
        }
        _this.tableData = data;
      }
      if (column.order !== null && column.prop === 'cargoType') {
        var _data = [];
        for (var _i = 0; _i < _this.tableData.length; _i++) {
          if (_this.tableData[_i].cargoType === null) {
            _data.push(_this.tableData[_i]);
          } else {
            _data.unshift(_this.tableData[_i]);
          }
        }
        _this.tableData = _data;
      }
      if (column.order === null) {
        _this.tableData = _this.tabData;
      }
      _this.sortRule.prop = column.prop;
      _this.sortRule.order = column.order;
    },
    /**
     * 导出excel
     */
    exportHandle: function exportHandle() {
      // alert("导出")
      (0, _Export2Excel.export_table_to_excel)('#out-charge-table', 'surchargeAndMiscellaneous');
      //, 'surchargeAndMiscellaneous'
    },
    /**
     * currentPage 改变时会触发
     */
    handleCurrentChange: function handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.toSearch();
    },
    /**
     * pageSize 改变时会触发
     */
    handleSizeChange: function handleSizeChange(val) {
      this.page.pageSize = val;
      this.toSearch();
    },
    toSearch: function toSearch() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this3.showDefault === true ? _this3.form.defaultPaidType = '1' : _this3.form.defaultPaidType = '0';
          _this3.form.date = (0, _date.dateFormat)('YYYY-MM-DD', new Date());
          _this3.loading = (0, _utils.load)();
          (0, _surchargeAndMiscellaneous.searchEC)(Object.assign({
            pageIndex: _this3.page.pageIndex,
            pageSize: _this3.page.pageSize
          }, _this3.form)).then(function (response) {
            _this3.tableData = response.data.data.list;
            _this3.tabData = response.data.data.list;
            _this3.page.total = _this3.validateNull(_this3.tableData) ? 0 : +_this3.tableData[0].maxRowNo;
            _this3.isResult = true;
          }).catch(function () {}).finally(function () {
            _this3.loading.close();
          });
        }
      });
    },
    //获取字节长度
    getBitNum: function getBitNum(str) {
      var len = str.split('').reduce(function (pre, cur) {
        return pre + (cur.charCodeAt() > 255 ? 2 : 1);
      }, 0);
      return len;
    }
  }
};